<template>
  <ApolloMutation
    :mutation="(gql) => createChapterQuery"
    :variables="{
      story: story.id,
      name: '',
    }"
    :update="updateCache"
  >
    <template v-slot="{ mutate, loading }">
      <v-btn
        class="mt-6 rounded-xl"
        color="primaryAction"
        @click="mutate()"
        :disabled="loading"
        >{{ $t("storyHub.chapterList.addNewChapter") }}</v-btn
      >
    </template>
  </ApolloMutation>
</template>
<script>
import { chapterQueries, chapterFragments } from "@/graphql/ChapterQueries";
export default {
  props: {
    story: Object,
  },
  methods: {
    updateCache(store, { data: { createChapter } }) {
      store.modify({
        id: store.identify(this.story),
        fields: {
          chapters(existingChapterRefs = [], { readField }) {
            const newChapterRef = store.writeFragment({
              data: createChapter.chapter,
              fragment: chapterFragments.newChapter,
            });

            if (
              existingChapterRefs.some(
                (ref) => readField("id", ref) === createChapter.chapter.id
              )
            ) {
              return existingChapterRefs;
            }

            return [...existingChapterRefs, newChapterRef];
          },
        },
      });
    },
  },
  computed: {
    createChapterQuery() {
      return chapterQueries.createChapter;
    },
  },
};
</script>
